export default __webpack_public_path__ + "static/media/links-pfreport-e.290aa0a2.png";